var _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_58193",
    "data-name": "Group 58193",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.094,
    height: 13.639,
    viewBox: "0 0 23.094 13.639",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(2.153 3.819)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M121.675,565.2a3.052,3.052,0,0,1,3,1.935c.077.18.048.4.192.55a14.992,14.992,0,0,1-.037,2.708,2.95,2.95,0,0,1-2.925,2.5c-4.858.017-9.716,0-14.574,0a1.657,1.657,0,0,1-.2-.023,1.466,1.466,0,0,1-.737-1.851c.173-.563.147-.571.752-.6.026,0,.051-.023.118-.055a1.065,1.065,0,0,1-.54-1.149c.028-.624.015-.624.6-.684.009,0,.015-.034.033-.076-.553-.2-.68-.683-.756-1.195a5.152,5.152,0,0,0-.106-.59c-.064-.238-.091-.435.337-.419a1.445,1.445,0,0,1-.78-1.059Q113.864,565.2,121.675,565.2Zm-1.521,5.23c.148-.165.235-.156.4,0,.361.344.752.657,1.1.955,0-.137,0-.378,0-.62,0-.715.005-1.43,0-2.145,0-.191.046-.278.256-.293a2.885,2.885,0,0,0,.886-.153h-4.763l-.012.047c.261.037.52.094.782.1.221.009.279.092.276.3-.011.838,0,1.676,0,2.514v.325l.08.034C119.484,571.144,119.827,570.8,120.154,570.431Z",
    transform: "translate(-106.053 -565.198)",
    fill: "#01d95a"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M114.557,549.406a14.992,14.992,0,0,1-.037,2.708,2.95,2.95,0,0,1-2.925,2.5c-4.858.016-9.716,0-14.574,0a1.657,1.657,0,0,1-.2-.023c-.726,0-1.453,0-2.179.013a1.038,1.038,0,0,0-1.032.88,1.061,1.061,0,0,0,.669,1.183,1.257,1.257,0,0,0,.461.067q8.449,0,16.9,0a5.072,5.072,0,0,0,5.048-5.07c0-1.128,0-2.257,0-3.385a5.056,5.056,0,0,0-5.062-5.16c-5.632-.032-11.265-.012-16.9-.008a1.074,1.074,0,1,0,.027,2.144q8.365,0,16.73,0a2.976,2.976,0,0,1,2.945,2.145,3.134,3.134,0,0,1,.116.994A3.265,3.265,0,0,1,114.557,549.406Z",
    transform: "translate(-93.596 -543.101)",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(1.844 3.019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M123.386,563.858a3.266,3.266,0,0,0-.01-1.011c-.122-.039-.107-.161-.138-.247a2.962,2.962,0,0,0-2.8-2.02q-7.948-.01-15.9-.008c-.3,0-.33.085-.195.321.088.154.156.319.232.48q7.811,0,15.622,0a3.052,3.052,0,0,1,3,1.935C123.271,563.489,123.242,563.7,123.386,563.858Z",
    transform: "translate(-104.269 -560.572)",
    fill: "#00b248"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(14.113 6.792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M176.4,585.734c.336-.355.679-.7,1.006-1.069.148-.165.235-.156.4,0,.361.344.752.657,1.1.955,0-.137,0-.378,0-.62,0-.715.005-1.43,0-2.145,0-.191.046-.278.256-.293a2.885,2.885,0,0,0,.886-.153h-4.763l-.012.047a7.885,7.885,0,0,0,.782.1c.22.009.279.092.276.3-.011.838,0,1.676,0,2.514v.325Z",
    transform: "translate(-175.262 -582.406)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenBook);
export default __webpack_public_path__ + "static/media/GreenBook.e872b2456618c1118b21f8781e024611.svg";
export { ForwardRef as ReactComponent };